/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Snap_To_Event_Ends_FailedInputs */

const en_snap_to_event_ends_failed = /** @type {(inputs: Snap_To_Event_Ends_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Snap to event ends failed with message: ${i?.error}`)
};

const fr_snap_to_event_ends_failed = /** @type {(inputs: Snap_To_Event_Ends_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alignement sur la fin des événements échoué : ${i?.error}`)
};

const de_snap_to_event_ends_failed = /** @type {(inputs: Snap_To_Event_Ends_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Snap to event ends failed with message: ${i?.error}`)
};

const it_snap_to_event_ends_failed = /** @type {(inputs: Snap_To_Event_Ends_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'operazione di aggancio all'evento non è riuscita con il messaggio: ${i?.error}`)
};

const ru_snap_to_event_ends_failed = /** @type {(inputs: Snap_To_Event_Ends_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сбой привязки к событию завершился с сообщением: ${i?.error}`)
};

const es_snap_to_event_ends_failed = /** @type {(inputs: Snap_To_Event_Ends_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El ajuste al evento finaliza con el mensaje: ${i?.error}`)
};

const zh_cn2_snap_to_event_ends_failed = /** @type {(inputs: Snap_To_Event_Ends_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`捕捉到事件结束失败，错误信息：${i?.error}`)
};

const ja_snap_to_event_ends_failed = /** @type {(inputs: Snap_To_Event_Ends_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント終了へのスナップが失敗し、次のメッセージが表示されました: ${i?.error}`)
};

const hi_snap_to_event_ends_failed = /** @type {(inputs: Snap_To_Event_Ends_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्नैप टू इवेंट विफल हो गया, संदेश के साथ: ${i?.error}`)
};

const pt_pt2_snap_to_event_ends_failed = /** @type {(inputs: Snap_To_Event_Ends_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A transição para o evento terminou com a mensagem: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Snap to event ends failed with message: {error}" |
*
* @param {Snap_To_Event_Ends_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_event_ends_failed = /** @type {((inputs: Snap_To_Event_Ends_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Event_Ends_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snap_to_event_ends_failed(inputs)
	if (locale === "de") return de_snap_to_event_ends_failed(inputs)
	if (locale === "it") return it_snap_to_event_ends_failed(inputs)
	if (locale === "ru") return ru_snap_to_event_ends_failed(inputs)
	if (locale === "es") return es_snap_to_event_ends_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_snap_to_event_ends_failed(inputs)
	if (locale === "ja") return ja_snap_to_event_ends_failed(inputs)
	if (locale === "hi") return hi_snap_to_event_ends_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_snap_to_event_ends_failed(inputs)
	return en_snap_to_event_ends_failed(inputs)
});